import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StepperService {
  private _steps!: string[];
  private _currentStep!: string;

  constructor() {}

  get steps(): string[] {
    return this._steps;
  }

  set steps(value: string[]) {
    this._steps = value;
    this.currentStep = value[0];
  }

  get currentStep(): string {
    return this._currentStep;
  }

  set currentStep(value: string) {
    this._currentStep = value;
  }

  get indexCurrentStep(): number {
    return this.steps.indexOf(this.currentStep);
  }

  /**
   * Check if exist next step
   * @return {boolean}
   */
  public hasNextStep(): boolean {
    return !!this.steps?.[this.steps.indexOf(this.currentStep) + 1];
  }

  /**
   * Check if exist previous step
   * @return {boolean}
   */
  public hasPreviousStep(): boolean {
    return !!this.steps[this.steps.indexOf(this.currentStep) - 1];
  }

  /**
   * Go to next step
   * @param {string} step
   */
  public nextStep(step: string): void {
    if (this.hasNextStep()) {
      this.currentStep = this.steps[this.steps.indexOf(step) + 1];
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  /**
   * Return to previous step
   * @param {string} step
   */
  public previousStep(step: string): void {
    if (this.hasPreviousStep()) {
      this.currentStep = this.steps[this.steps.indexOf(step) - 1];
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
